<template>
  <section class="edit-tag">
    <Modal 
      id="modalId"
      v-model:show="active"
      @close="close"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          <span v-show="!edit">{{ $t('tagManager.card.addTag') }}</span>
          <span v-show="edit">{{ $t('tagManager.card.editTag') }}</span>
        </h5>
      </template>

      <form>
        <div
          class="row border-bot"
          :class="{wavebg: loading}"
        >
          <div class="col-12">
            <div class="form-group select-wrapper mt-0 mb-0">
              <UiInput
                v-model="form.name"
                v-model:error="errors.name"
                :label="$t('tagManager.tags.fields.name.title')"
                :placeholder="$t('tagManager.tags.fields.name.title')"
                error-clear-on-change
              />
            </div>
          </div>
          <div class="col-12 mt-10">
            <div class="select-wrapper">
              <UiLabel :label="$t('tagManager.tags.fields.platform.title')" />
              <div class="request__radio-wrapper">
                <div
                  v-for="(platform, i) in platforms"
                  :key="i"
                  class="request__radio-one"
                >
                  <input
                    :id="platform"
                    v-model="form.platform"
                    :value="platform"
                    type="radio"
                    name="radio-group"
                    :disabled="platform !== 'Landings' && platform !== 'PWA' && platform !== 'Product'"
                    @change="form.triggers = {};"
                  >
                  <label :for="platform">{{ platform }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-10">
            <div class="select-wrapper">
              <UiLabel :label="$t('tagManager.tags.fields.triggers.title')" />
              <div class="send__check-wrapper row">
                <div class="send__col-one col-12 row">
                  <div
                    v-for="(trigger, i) in triggers"
                    :key="i"
                    class="send__checkbox-item checkbox col-6"
                  >
                    <input
                      :id="trigger"
                      v-model="form.triggers[trigger]"
                      type="checkbox"
                      @change="() => clearError('triggers')"
                    >
                    <label
                      class="checkbox-label"
                      :class="{'checkbox-check': form.triggers[trigger]}"
                      :for="trigger"
                    >{{ $t(`tagManager.triggers.${trigger}`) }}</label>
                  </div>
                </div>
              </div>
              <UiHelp
                v-if="errors.triggers"
                :is-error="true"
                :text="errors.triggers"
              />
            </div>
          </div>

          <div class="col-12 mt-10">
            <UiSelect
              v-model="form.template"
              :label="$t('tagManager.tags.fields.template.title')"
              :list="templates"
              @change="onTemplateChange"
            />
            <UiHelp
              v-if="errors.template"
              :is-error="true"
              :text="errors.template"
            />
          </div>
          <div
            v-if="showAttributes"
            class="col-12"
          >
            <div
              v-for="(attribute, i) of attrributes"
              :key="i"
              class="form-group select-wrapper"
            >
              <UiLabel
                class="mb-4"
                :label="attribute.name"
              />
              <!--              <UiTextarea-->
              <!--                v-if="!attribute.is_tokens_applicable && attribute.input_type === 'multiline'"-->
              <!--                v-model="form[attribute.key]"-->
              <!--                :placeholder="attribute.name"-->
              <!--                :rows="3"-->
              <!--                :is-error="errors[attribute.key]"-->
              <!--                @input="v => onChange(attribute.key, v)"-->
              <!--              />-->
              <TokenInput
                v-if="attribute.is_tokens_applicable"
                :id="attribute.key"
                v-model="form[attribute.key]"
                :placeholder="attribute.name"
                :tokens="tokens"
                :rows="attribute.input_type === 'multiline' ? 3 :1"
                :error="attribute.value_type === 'json' ? errors[`${attribute.key}_json`] : errors[attribute.key]"
                @input="attribute.value_type === 'json' ? clearError(`${attribute.key}_json`) : clearError(attribute.key)"
              />
              <UiInput
                v-else
                v-model="form[attribute.key]"
                :placeholder="attribute.name"
                :error="errors.attributes?.[attribute.key]"
                error-clear-on-change
              />
              <UiHelp
                v-if="attribute.is_required && errors[attribute.key]"
                :is-error="true"
                :text="errors[attribute.key]"
              />
              <UiHelp
                v-if="attribute.value_type === 'json' && errors[`${attribute.key}_json`]"
                :is-error="true"
                :text="errors[`${attribute.key}_json`]"
              />
            </div>
          </div>
        </div>
      </form>

      <template v-slot:footer>
        <div class="!tw-text-right">
          <div class="tagmanager__btn-save-wrap">
            <a
              class="btn btn-outline-primary btn-sm mt-8 mb-4"
              @click="close"
            >
              {{ $t('trafficSources.addTrafficSources.cancel') }}
            </a>
            <a
              class="btn btn-primary btn-sm ml-16 mt-8 mb-4"
              @click="() => saveTag()"
            >
              {{ !edit ? $t('tagManager.card.addTag') : $t('tagManager.card.editTag') }}
            </a>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import { Modal, TokenInput } from '@/components';

export default {
  components: {
    TokenInput,
    Modal,
  },
  emits: ['success'],
  data() {
    return {
      active: false,
      edit: false,
      loading: false,
      form: {
        triggers: {},
      },
      // triggers: ['page_load', 'page_close', 'signup'],
      dropdownFiltersSettings: {
        minimumResultsForSearch: Infinity,
      },
      errors: {},
    };
  },
  props: ['passedParams', 'platforms'],
  computed: {
    triggers() {
      return ['page_load', 'page_close', 'signup'];
    },
    templates() {
      return this.$store.state.misc.tagTemplates.map((tt) => ({
        id: tt.id,
        text: tt.name,
      }));
    },
    showAttributes() {
      if (!this.form.template) {
        return false;
      }

      const template = this.$store.state.misc.tagTemplates.find((tt) => tt.id === this.form.template);
      return template && template.attributes.length > 0;
    },
    attrributes() {
      if (!this.form.template) {
        return [];
      }

      const template = this.$store.state.misc.tagTemplates.find((tt) => tt.id === this.form.template);
      return template ? template.attributes : [];
    },
    tokens() {
      return this.$store.state.settings.tag_manager_tokens;
    },
  },
  methods: {
    open(id) {
      this.loading = !!id;
      this.edit = !!id;
      this.active = true;

      if (id) {
        this.$store.dispatch('getTag', id)
          .then((tag) => {
            this.form = {
              id: tag.id,
              name: tag.name,
              template: tag.tag_manager_template_id,
              platform: this.platforms.find((p) => p.toLowerCase() === tag.embed_platform),
              triggers: this.triggers.reduce((result, item) => ({
                ...result,
                [item]: tag.triggers.includes(item),
              }), {}),
              ...tag.attributes,
            };

            this.loading = false;
          });
      } else {
        const defaultTemplate = this.$store.state.misc.tagTemplates[0];

        if (defaultTemplate) {
          this.form = { ...this.form };
          this.form.template = defaultTemplate.id;
          this.form.platform = 'Landings';
          this.onTemplateChange(this.form.template);
        }
      }

      this.clearTooltip();
    },
    close() {
      this.resetForm();
      this.active = false;
    },
    async saveTag() {
      if (this.validateForm()) {
        const template = this.$store.state.misc.tagTemplates.find((tt) => tt.id === this.form.template);

        if (template) {
          const tagParams = {
            data: {
              traffic_source_id: this.$store.state.trafficSource.item.id,
              tag_manager_template_id: this.form.template,
              name: this.form.name,
              embed_platform: this.form.platform.toLowerCase(),
              triggers: Object.entries(this.form.triggers)
                .filter(([, v]) => v)
                .map(([k]) => k),
              attributes: template.attributes.reduce((result, item) => ({
                ...result,
                [item.key]: this.form[item.key],
              }), {}),
            },
            passedParams: {
              ...this.passedParams,
              traffic_source_id: this.$store.state.trafficSource.item.id,
            },
          };

          if (!this.edit) {
            await this.$store
              .dispatch('createTag', tagParams)
              .then(() => {
                this.$emit('success');
                this.$alert.success(this.$t('tagManager.messages.wasCreated'));
                this.close();
              }).catch((err) => {
                this.errors = err.response.data.errors;
                if(this.errors.triggers) {
                  this.errors.triggers = this.$t('tagManager.errors.triggerRequired');
                }
              });
          } else {
            tagParams.data.id = this.form.id;
            await this.$store
              .dispatch('updateTag', tagParams)
              .then(() => {
                this.$emit('success');
                this.$alert.success(this.$t('tagManager.messages.wasUpdated'));
                this.close();
              }).catch((err) => {
                this.errors = err.response.data.errors;
                if(this.errors.triggers) {
                  this.errors.triggers = this.$t('tagManager.errors.triggerRequired');
                }
              });
          }
        }
      }
    },
    validateForm() {
      this.errors = {};

      // Name
      // if (!this.form.name) {
      //   this.errors.name = this.$t('tagManager.errors.nameRequired');
      // }

      // // Triggers
      // if (Object.values(this.form.triggers).filter((v) => v).length === 0) {
      //   this.errors.triggers = this.$t('tagManager.errors.triggerRequired');
      // }

      // Template
      if (!this.form.template) {
        this.errors.template = this.$t('tagManager.errors.templateRequired');
      } else {
        const template = this.$store.state.misc.tagTemplates.find((tt) => tt.id === this.form.template);

        if (template) {
          template.attributes.forEach((a) => {
            // if (a.is_required && !this.form[a.key]) {
            //   this.errors[a.key] = `${a.name} ${this.$t('tagManager.errors.isRequired')}`;
            // }

            if (a.value_type === 'json' && this.form[a.key] && !this.isJson(this.form[a.key])) {
              this.errors[`${a.key}_json`] = `${a.name} ${this.$t('tagManager.errors.invalidJson')}`;
            }
          });
        }
      }

      return Object.keys(this.errors).length === 0;
    },
    resetForm() {
      this.errors = {};
      this.form = {
        triggers: {},
      };
    },
    // onChange(key, value) {
    //   this.clearError(key);
    //   this.form[key] = value;
    // },
    onTemplateChange(id) {
      const template = this.$store.state.misc.tagTemplates.find((tt) => tt.id === id);

      if (template) {
        template.attributes.forEach((a) => {
          this.form[a.key] = a.default_value;
        });
      }

      // this.clearError('template');
    },
    clearError(key) {
      delete this.errors[key];
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }

      return true;
    },
    clearTooltip() {
      const tooltips = document.querySelectorAll('.el-tooltip__popper');
      tooltips.forEach((e, i) => {
        tooltips[i].style.display = 'none';
      });
    },
  },
};
</script>

<style lang="scss">
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/trafficsources/tagmanager';
</style>
